import FaqsCategory from "./FaqsCategory";
import AddFaqCategory from "./AddFaqCategory";
import EditFaqCategory from "./EditFaqCategory";
import DeleteFaqCategory from "./DeleteFaqCategory";
import Faqs from "./Faqs";
import AddFaq from "./AddFaq";
import EditFaq from "./EditFaq";
import DeleteFaq from "./DeleteFaq";

export {
    FaqsCategory,
    AddFaqCategory,
    EditFaqCategory,
    DeleteFaqCategory,
    Faqs,
    AddFaq,
    EditFaq,
    DeleteFaq,
}